import { render, staticRenderFns } from "./IndexMode.vue?vue&type=template&id=22c9f8cc&"
import script from "./IndexMode.vue?vue&type=script&lang=js&"
export * from "./IndexMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c9f8cc')) {
      api.createRecord('22c9f8cc', component.options)
    } else {
      api.reload('22c9f8cc', component.options)
    }
    module.hot.accept("./IndexMode.vue?vue&type=template&id=22c9f8cc&", function () {
      api.rerender('22c9f8cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/components/IndexMode.vue"
export default component.exports